import Vue from "vue";
import Vuex from "vuex";
import { getToken, setToken, removeToken, getImToken, setImToken, removeImToken } from "@/utils/cookies";
import { getUnreadCount, getStaffInfo } from "@/services/api/api";
import { notification } from "@/utils/notification";
import router from "@/router";
import i18n from "@/i18n/config";
import uploadingMessages from "./modules/uploading-messages";
Vue.use(Vuex);

const defaultTitle = "OMELink Sales workbench";

const alertAudio = new Audio("../../static/audio/alert.wav");

const store = new Vuex.Store({
	modules: {
		uploadingMessages, // 上传消息模块
	},
	state: {
		user: {
			id: null, // 用户ID
			nickName: null, // 昵称
			avatar: null, // 头像
			userName: null, // 用户名
			isLogin: false, // 是否登陆
			token: null, // TOKEN
		},

		staff: {
			id: null, // 用户ID
			userName: null, // 用户名
			isLogin: false, // 是否登陆
			token: null, // TOKEN
		},

		socket: {
			isConnected: false, // 是否连接WebSocket
			message: null, // 消息
			reconnectError: false, // 重连是否存在错误
			pingInterval: null, // 心跳定时器
		},

		chat: {
			audios: [], // 聊天音频列表
			totalUnread: 0, // 未读消息总数
		},
	},
	mutations: {
		// 设置用户信息
		SET_USER(state, user) {
			state.user.isLogin = true;
			state.user.id = user.id;
			state.user.nickName = user.nick_name;
			state.user.avatar = user.avatar;
			state.user.userName = user.username;
			state.user.token = getImToken();
		},

		// 设置用户头像
		SET_USER_AVATAR(state, avatar) {
			state.user.avatar = avatar.avatar;
		},

		// 移除用户信息
		REMOVE_USER(state) {
			state.user.isLogin = false;
			state.user.id = null;
			state.user.nickName = null;
			state.user.avatar = null;
			state.user.userName = null;
			state.user.token = null;
		},

		// 设置STAFF信息
		SET_STAFF(state, staff) {
			state.staff.isLogin = true;
			state.staff.id = staff.id;
			state.staff.userName = staff.user_name;
			state.staff.token = getToken();
		},

		// 设置未读数量
		SET_TOTAL_UNREAD(state, totalUnread) {
			state.chat.totalUnread = totalUnread;
			if (totalUnread > 0) {
				document.title = `(${i18n.t("storeIndexJS.have")}${totalUnread}${i18n.t("storeIndexJS.unreadMessages")}) ${defaultTitle}`;
			} else {
				document.title = defaultTitle;
			}
		},

		// 设置未读数量自减
		DECREMENT_TOTAL_UNREAD(state) {
			state.chat.totalUnread--;
			if (!state.chat.totalUnread < 1) {
				document.title = `(${i18n.t("storeIndexJS.have")}${state.chat.totalUnread}${i18n.t("storeIndexJS.unreadMessages")}) ${defaultTitle}`;
			} else {
				document.title = defaultTitle;
			}
		},

		// 设置未读数量自增
		INCREMENT_TOTAL_UNREAD(state) {
			state.chat.totalUnread++;
			if (state.chat.totalUnread > 0) {
				document.title = `(${i18n.t("storeIndexJS.have")}${state.chat.totalUnread}${i18n.t("storeIndexJS.unreadMessages")}) ${defaultTitle}`;
			} else {
				document.title = defaultTitle;
			}
		},

		// 移除STAFF信息
		REMOVE_STAFF(state) {
			state.staff.isLogin = false;
			state.staff.id = null;
			state.staff.userName = null;
			state.staff.token = null;
		},

		// 连接成功
		SOCKET_ONOPEN(state, event) {
			Vue.prototype.$socket = event.currentTarget;
			state.socket.isConnected = true;
			console.log("connection success.");
			// 心跳定时器
			if (state.socket.pingInterval === null) {
				state.socket.pingInterval = setInterval(() => {
					if (state.socket.isConnected) {
						Vue.prototype.$socket.send(
							JSON.stringify({
								controller: "app",
								action: "ping",
							})
						);
					}
				}, 5000);
			}
		},

		// 连接关闭
		SOCKET_ONCLOSE(state, event) {
			state.socket.isConnected = false;
			console.log("connection close.");
		},

		// 连接错误
		SOCKET_ONERROR(state, event) {
			console.error(state, event);
			console.log("connection error.");
		},

		// 消息发送
		SOCKET_SEND_MESSAGE(state, message) {
			Vue.prototype.$socket.send(JSON.stringify(message));
			state.socket.message = message;
		},

		// 消息接收
		SOCKET_ONMESSAGE(state, event) {
			let messageData;

			try {
				const obj = JSON.parse(event.data);
				if (typeof obj === "object") {
					messageData = obj;
				} else {
					console.warn(event.data);
					return;
				}
			} catch (e) {
				console.warn(event.data);
				return;
			}

			state.socket.message = messageData;
		},

		// 重新连接
		SOCKET_RECONNECT(state, count) {
			console.info(state, count);
		},

		// 重新连接错误
		SOCKET_RECONNECT_ERROR(state) {
			state.socket.reconnectError = true;
		},
	},

	actions: {
		login({ commit }, loginParams) {
			// return new Promise((resolve, reject) => {
			//     login(loginParams).then((result) => {
			//         if (result.status) {
			//             setToken(result.data.token); // 设置Token
			//             setImToken(result.data.im_token) // 设置IM Token
			//             commit('SET_USER', result.data.user) // 设置用户信息
			//             commit('SET_STAFF', result.data.staff) // 设置STAFF信息
			//         }
			//         resolve(result)
			//     }).catch(error => {
			//         reject(error)
			//     })
			// })
		},

		logout({ commit }) {
			removeImToken();
			removeToken();
			commit("REMOVE_USER");
			commit("REMOVE_STAFF");

			// 登出时清空上传消息
			commit("uploadingMessages/CLEAR_ALL");
		},

		getStaffInfo({ commit }) {
			getStaffInfo().then((result) => {
				commit("SET_USER", result.data.user);
				commit("SET_STAFF", result.data.staff);
			});
		},

		getTotalUnread({ commit }) {
			getUnreadCount().then((result) => {
				const totalUnread = result.data.unread;
				commit("SET_TOTAL_UNREAD", totalUnread);
			});
		},

		upateUserAvatar({ commit }, avatar) {
			commit("SET_USER_AVATAR", avatar);
		},
	},
});

// 当监听到完成Soket连接时向服务端发出绑定消息
store.subscribe((mutation, state) => {
	if (mutation.type === "SOCKET_ONMESSAGE" && state.socket.message && state.socket.message.event === "messageReceived") {
		alertAudio.play();

		if (router.currentRoute.path !== "/chat") {
			store.commit("INCREMENT_TOTAL_UNREAD");

			notification("", i18n.t("storeIndexJS.haveNewMessage"));
		}
	}
});

export default store;
